/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const ticketUserDetailsDataSchema = z.object({
  userId: z.string(),
  userName: z.string(),
  userEmail: z.string(),
  image: z.string().nullable(),
  primaryLanguage: z.string().nullable(),
  detectiveMode: z.boolean(),
  createdAt: z.string().nullable(),
});

export type ITicketUserDetailsData = z.infer<typeof ticketUserDetailsDataSchema>;

export const ticketUserDetailsResponseSchema = createApiResponseSchema(
  ticketUserDetailsDataSchema,
) as z.ZodSchema<IAPI<ITicketUserDetailsData>>;

export type ITicketUserDetailsResponse = IAPI<ITicketUserDetailsData>;
